import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const H2Icon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`H2`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M8 3.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8.75H3.417V12a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 1.5 0v3.25H7.25V4A.75.75 0 0 1 8 3.25Zm3.04 3.372c.786-.53 1.64-.658 2.363-.417.763.254 1.347.928 1.347 1.795 0 .7-.246 1.218-.626 1.613-.333.347-.777.596-1.06.773-.324.202-.549.368-.708.587a1.24 1.24 0 0 0-.152.277H14l.076.004a.75.75 0 0 1 0 1.492L14 12.75h-2.667a.75.75 0 0 1-.75-.75c0-.803.205-1.421.56-1.91.341-.469.783-.761 1.126-.976.383-.24.606-.365.773-.54.12-.125.208-.274.208-.574 0-.133-.084-.293-.321-.372-.23-.076-.643-.072-1.146.306l-.063.043a.75.75 0 0 1-.837-1.244l.156-.11Z"
    />
  </Icon>
);
